module.exports = __webpack_public_path__ + "static/img/10.9b0401a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/10.png
// module id = kdcE
// module chunks = 0